module.exports = __webpack_public_path__ + "static/media/logo_text_cn@2x.a80f54d9.png";